import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.warn10};
  border-radius: ${({ theme }) => theme.rounded.x3};
  padding: ${({ theme }) => theme.spacing.x4};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
`;

export const containerTitleAndBtnFreeTicket = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const FlightTypesWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.x4};
`;
